/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */
/**
 * 布局组件
 */
import Footer from './Footer';
import { Question, SelectLang } from './RightContent';
import { AvatarDropdown, AvatarName } from './RightContent/AvatarDropdown';

/**
 * 表单组件
 */
import IconPicker from './IconPicker';
import ImageUpload from './ImageUpload';
import MarkdownEditor from './MarkdownEditor';
import RichTextEditor from './RichTextEditor';

export {
  AvatarDropdown,
  AvatarName,
  Footer,
  IconPicker,
  ImageUpload,
  MarkdownEditor,
  Question,
  RichTextEditor,
  SelectLang,
};
